import {useRoutes} from "react-router-dom";

import {useCoopEnforcedRoute} from "~/routes/page/coop/hooks/useCoopEnforcedRoute";
import PlayTestLevelWrapper from "~/routes/page/edit-level/play-test/PlayTestLevelWrapper";
import LeaderboardPage from "~/routes/page/play-level/leaderboard/LeaderboardPage";
import PlaylistSelector from "~/routes/page/playlist/PlaylistSelector";
import ViewSinglePlaylist from "~/routes/page/playlist/view/ViewSinglePlaylist";

import {ProtectedRoute} from "./ProtectedRoute";
import CoopHtmlWrapper from "./page/coop/CoopHtmlWrapper";
import Create from "./page/create/Create";
import EditLevelWrapper from "./page/edit-level/EditLevelWrapper";
import Home from "./page/home/Home";
import PlayLevelHtmlWrapper from "./page/play-level/PlayLevelHtmlWrapper";
import ManageSinglePlaylist from "./page/playlist-edit/ManageSinglePlaylist";

const HtmlRoutes = () => {
  useCoopEnforcedRoute();
  return useRoutes([
    {
      path: "/",
      element: <ProtectedRoute />,
      children: [
        {
          path: "home",
          element: <Home />,
        },
        {
          path: "play",
          element: <PlaylistSelector />,
        },
        {
          path: "playlist/:playlistId/play/:id",
          element: <PlayLevelHtmlWrapper />,
        },
        {
          path: "playlist/:playlistId/play/:id/leaderboard",
          element: <LeaderboardPage />,
        },
        {
          path: "coop",
          element: <CoopHtmlWrapper />,
        },
        {
          path: "create",
          element: <Create />,
        },
        {
          path: "create/:id",
          element: <EditLevelWrapper />,
        },
        {
          path: "create/:id/test",
          element: <PlayTestLevelWrapper />,
        },
        {
          path: "playlist/:playlistId",
          element: <ViewSinglePlaylist />,
        },
        {
          path: "playlist/:playlistId/edit",
          element: <ManageSinglePlaylist />,
        },
      ],
    },
  ]);
};

export default HtmlRoutes;
